import script from "./TppSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./TppSummary.vue?vue&type=script&setup=true&lang=ts"

import "./TppSummary.vue?vue&type=style&index=0&id=57163ecc&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57163ecc"]])

export default __exports__